import { render, staticRenderFns } from "./FTtransactions.vue?vue&type=template&id=22da5c43&"
import script from "./FTtransactions.vue?vue&type=script&lang=js&"
export * from "./FTtransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports